import { render, staticRenderFns } from "./ProyectosView.vue?vue&type=template&id=5f5f215e&scoped=true"
import script from "./ProyectosView.vue?vue&type=script&lang=js"
export * from "./ProyectosView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5f215e",
  null
  
)

export default component.exports